import { useSelector } from "react-redux";
import store from "../../stores/store";
import FeaturesTable from "../controls/featuresTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useEffect } from "react";
import { formatSelectedFeatures, key, trans } from "../../lib/utils";

function FavoritesResults() {
  const results = useSelector((state) => store.getState().results);

  const favorites = results.favoriteResults;

  const activeTab =
    results.resultsPanelActiveTab === "favoriteResults"
      ? "favoriteResults".concat(Object.keys(favorites).length - 1)
      : results.resultsPanelActiveTab;

  const layers = useSelector((state) => store.getState().layers);

  return (
    <>
      <PerfectScrollbar style={{ height: "45px" }}>
        <ul className="nav nav-tabs navbar-expand small">
          {Object.keys(favorites)?.map((favorite, idx) => {
            return (
              <li
                className="nav-item "
                role="button"
                onClick={() => {
                  window["recaclulatePerfectScrollbarHeight"]();
                }}
              >
                <span
                  className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                    activeTab.startsWith("favoriteResults".concat(idx))
                      ? "active"
                      : ""
                  )}
                  onClick={() => {
                    store.dispatch({
                      type: "results/setActiveTab",
                      payload: "favoriteResults".concat(idx),
                    });
                  }}
                >
                  <span className="color-black">
                    {layers[favorite].title.concat(
                      " (",
                      favorites[favorite]?.data?.length,
                      ")"
                    )}
                  </span>
                  <i
                    className="fas fa-times ms-2 results-close-icon"
                    onClick={() => {
                      window["primaryModal"].setState({
                        show: true,
                        size: "default",
                        title: "Delete confirmation",
                        body: (
                          <div className="p-2">
                            {trans("Are you sure you want to remove")}{" "}
                            <strong>'{layers[favorite]?.title}'</strong>{" "}
                            {trans("tab")}?
                          </div>
                        ),
                        footer: [
                          <button
                            className="btn btn-sm btn-link"
                            onClick={(e) => {
                              window["primaryModal"].setState({
                                show: false,
                              });
                            }}
                          >
                            {trans("Cancel")}
                          </button>,
                          <button
                            className="btn btn-sm btn-danger text-white"
                            onClick={(e) => {
                              store.dispatch({
                                type: "results/favoriteResults/delete",
                                payload: {
                                  id: favorite,
                                },
                              });
                              window["primaryModal"].setState({
                                show: false,
                              });
                            }}
                          >
                            {trans("Delete")}
                          </button>,
                        ],
                      });
                    }}
                  ></i>
                </span>
              </li>
            );
          })}
        </ul>
      </PerfectScrollbar>
      <div className="tab-content ">
        {Object.keys(favorites)?.map((favorite, idx) => {
          return (
            <div
              className={"tab-pane fade ".concat(
                activeTab.startsWith("favoriteResults".concat(idx))
                  ? "show active"
                  : ""
              )}
              role="tabpanel"
            >
              <FeaturesTable
                key={key()}
                data={favorites[favorite].data}
                attributes={layers[favorite].attributes}
                layerId={favorite}
                withScrollbar={true}
                withDownloadFeatures={true}
                withChart={true}
                selected={favorites[favorite]?.params?.selected}
                onSelect={(selected) => {
                  store.dispatch({
                    type: "results/favoriteResults/params/update",
                    payload: {
                      id: favorite,
                      property: "selected",
                      value: formatSelectedFeatures(
                        selected,
                        favorites[favorite]?.params?.selected
                      ),
                    },
                  });
                }}
              ></FeaturesTable>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default FavoritesResults;
